import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/contexts/LanguageContext";
import manifest from "@/legal/terms-manifest.json";

export default function TermsUpdate() {
  const { lang } = useI18n();
  const [status, setStatus] = useState(null);
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const it = lang === "it";
  const text = manifest.languages[lang];
  useEffect(() => {
    if (manifest.status !== "published") return undefined;
    let active = true;
    api.get("/account/terms").then(({ data }) => { if (active) setStatus(data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, []);
  useEffect(() => { setChecked(false); }, [lang]);
  if (manifest.status !== "published") return null;
  if (!status) return error ? <p role="status">{it ? "Verifica dei Termini non disponibile. Riprova ricaricando la pagina." : "Terms check unavailable. Reload the page to try again."}</p> : null;
  if (!status.available || status.state === "accepted") return null;
  const matches = status.version === manifest.version && status.hashes?.[lang] === text.sha256;
  const decide = async (decision) => {
    if (busy || !matches || (decision === "accept" && !checked)) return;
    setBusy(true); setError(false);
    try {
      const { data } = await api.post("/account/terms", { version: manifest.version, language: lang, sha256: text.sha256, decision });
      setStatus(old => ({ ...old, ...data })); setChecked(false);
      window.dispatchEvent(new Event("nvl-terms-updated"));
    } catch { setError(true); }
    finally { setBusy(false); }
  };
  return <section aria-label={it ? "Aggiornamento dei Termini" : "Terms update"} className="nvl-card p-5 mb-6">
    <h2>{it ? "Termini del lancio gratuito" : "Free launch Terms"}</h2>
    <p>{it ? "Nessun passaggio automatico a pagamento. Questa scelta riguarda i Termini, non i consensi privacy." : "No automatic paid subscription. This choice concerns the Terms, not privacy consent."}</p>
    {!matches ? <p role="alert">{it ? "Il testo è stato aggiornato. Ricarica la pagina prima di scegliere." : "The text has changed. Reload before choosing."}</p> : <>
      <details><summary>{it ? "Leggi il testo completo" : "Read the full text"}</summary>
        <p>{text.document.intro}</p>
        {text.document.sections.map(s => <div key={s.title}><h3>{s.title}</h3><p style={{ whiteSpace: "pre-wrap" }}>{s.body}</p></div>)}
      </details>
      {status.state === "declined" && <p role="status">{it ? "Hai scelto di non accettare. Non abbiamo registrato una nuova accettazione. Puoi cambiare scelta qui." : "You chose not to accept. No new acceptance was recorded. You may change your choice here."}</p>}
      <label><input type="checkbox" checked={checked} disabled={busy} onChange={e => setChecked(e.target.checked)} /> {text.acceptance_text}</label>
      <div><button type="button" disabled={busy || !checked} onClick={() => decide("accept")}>{it ? "Conferma accettazione" : "Confirm acceptance"}</button>{" "}
      <button type="button" disabled={busy || status.state === "declined"} onClick={() => decide("decline")}>{it ? "Non accetto" : "I do not accept"}</button></div>
    </>}
    {error && <p role="alert">{it ? "Scelta non confermata. Ricarica la pagina per verificare e riprovare." : "Choice not confirmed. Reload to check and retry."}</p>}
    <p><Link to="/app/settings/privacy">{it ? "Privacy, esportazione e cancellazione" : "Privacy, export and deletion"}</Link>{" · "}<a href="mailto:info@gd8.it">{it ? "Assistenza" : "Support"}</a></p>
  </section>;
}
